import { BASE_PATH } from 'common/constants';

export function openPaymentWindow(url) {
  openWindow(url, 'Atlas Payment Window', {
    height: 620,
    width: 810,
  });
}

export function openPaymentForm(data) {
  const url = window.BASE_PATH +
  '/static/assets/pages/payment-form.html?' +
    `redirectUrl=${encodeURIComponent(data.redirectUrl)}&` +
    `formData=${encodeURIComponent(JSON.stringify(data.formData))}`;

  openWindow(BASE_PATH + url, 'Payment Form', {
    height: 620,
    width: 810,
  });
}

export function openWithdrawWindow(url) {
  openWindow(url, 'Atlas Withdraw Window', {
    height: 620,
    width: 810,
  });
}

function openWindow(url, target, options) {
  // With dual screen fix
  const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
  const dX = (window.screen.width - options.width) / 2 + screenLeft;
  const dY = (window.screen.height - options.height) / 2 + screenTop;

  const features = `top=${dY},left=${dX},width=${options.width},height=${options.height}`;

  const win = window.open('', target, features);

  win.opener = null;
  win.location = url;
}
